import { useWatch } from 'react-hook-form';

import { PropertyGridRow } from '../rows/PropertyGridRow.tsx';
import { TitleRow } from '../rows/TitleRow.tsx';
import {
  PropertyGridSectionProps as BasePropertyGridSectionProps,
  PropertyGridField,
} from '../types.ts';

type PropertyGridSectionProps = BasePropertyGridSectionProps & {
  title: string;
  fields: PropertyGridField[];
};

export const PropertyGridSection = ({
  fields,
  title,
  isRemovable,
  onRemove,
  ...propertySectionProps
}: PropertyGridSectionProps) => {
  const { columnIndex, fieldTypes, feature, control, getValues } = propertySectionProps;

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);

  const hasFeatureKey = feature === 'manualCost' ? 'hasManualCost' : `${feature}.hasFeature`;
  const featurePath = feature
    ? `columns.${columnIndex}.propertyData.editableData.improvements.${hasFeatureKey}`
    : `columns.${columnIndex}.propertyId`;

  const watchedValue: boolean = useWatch({ control, name: featurePath as any });

  let sectionIsNone = false;

  if (propertyId !== 'subject' && feature) {
    const hasFeature = watchedValue as boolean;
    if (!hasFeature) sectionIsNone = true;
  }

  return (
    <>
      <TitleRow
        columnIndex={columnIndex}
        fieldTypes={fieldTypes}
        title={title}
        feature={feature}
        isRemovable={isRemovable}
        onRemove={onRemove}
        control={control}
        getValues={getValues}
      />
      {fields.map((field) => (
        <PropertyGridRow
          key={field.label}
          field={field}
          sectionIsNone={sectionIsNone}
          {...propertySectionProps}
        />
      ))}
    </>
  );
};
